// extracted by mini-css-extract-plugin
module.exports = {"gatsbyImageWrapper":"figure-module--gatsby-image-wrapper--UAPDT","root":"figure-module--root--2-Ux9"};